<!--
/**
  安心充退款管理列表 
*/
-->
<template>
  <scroll-layout>
    <template #header>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="anxin-refund-main">
      <ykc-table
        ref="YkcTable"
        :data="tableData"
        :columns="tableColumns"
        title="安心充退款列表"
        operateFixedType="right"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          direct="flex-end"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageIndex"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { code } from '@/utils';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { orderPage } from '@/service/apis';

  export default {
    name: 'AnxinRefundList',

    data() {
      return {
        tableData: [],
        tableColumns: [
          { label: '充电单号', prop: 'tradeSeq', width: '200px', fixed: true },
          { label: '充电用户', prop: 'userAccount', minWidth: '150px' },
          { label: '终端编码', prop: 'gunCode', minWidth: '150px' },
          { label: '商户名称', prop: 'mchName', minWidth: '200px' },
          { label: '退款类型', prop: 'refundTypeName', minWidth: '100px' },
          { label: '退款原因', prop: 'reason', minWidth: '150px' },
          { label: '退款金额', prop: 'refundAmt', minWidth: '100px' },
          { label: '申请人', prop: 'createdNo', minWidth: '100px' },
          { label: '申请时间', prop: 'createdTime', minWidth: '150px' },
          { label: '操作员', prop: 'modifiedNo', minWidth: '100px' },
          { label: '财务审核时间', prop: 'modifiedTime', minWidth: '150px' },
          {
            label: '退款状态',
            prop: 'status',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                const statusMap = {
                  1: '待审核',
                  2: '已通过',
                  3: '已拒绝',
                  4: '已退款',
                };
                return <span>{statusMap[row.status] || '未知'}</span>;
              },
            },
          },
          { label: '退款失败原因', prop: 'failReason', minWidth: '200px' },
          { label: '备注', prop: 'remark', minWidth: '200px' },
        ],
        tableOperateButtons: [
          {
            enabled: () => code('finance:account:anxin:refund:pass'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                disabled={row.status !== 1}
                onClick={() => {
                  this.refundStatus(row, 1);
                }}>
                通过
              </ykc-button>
            ),
          },
          {
            enabled: () => code('finance:account:anxin:refund:refuse'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                disabled={row.status !== 1}
                onClick={() => {
                  this.refundStatus(row, 2);
                }}>
                拒绝
              </ykc-button>
            ),
          },
          {
            enabled: () => code('finance:account:anxin:refund:detail'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.$router.push({
                    path: '/financialManagement/accountManagement/anxinRefund/detail',
                    query: { id: row.id },
                  });
                }}>
                详情
              </ykc-button>
            ),
          },
        ],
        pageInfo: {
          pageIndex: 1,
          pageSize: 10,
          total: 0,
        },
        searchParams: {
          // 查询参数
        },
        statusData: [
          { id: 1, name: '待审核' },
          { id: 2, name: '已通过' },
          { id: 3, name: '已拒绝' },
          { id: 4, name: '已退款' },
        ],
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'tradeSeq',
            label: '充电单号',
            placeholder: '请输入充电单号',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '充电用户',
            placeholder: '请输入充电用户',
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '退款状态',
            placeholder: '请选择退款状态',
            data: this.statusData,
          },
          {
            comName: 'YkcDatePicker',
            key: 'date',
            label: '申请时间',
            placeholder: '请选择申请时间',
          },
        ];
      },
    },
    mounted() {
      this.requestList();
    },
    methods: {
      /**
       * 获取列表数据
       */
      requestList() {
        const params = {
          ...this.searchParams,
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };
        orderPage.anxinRefundPage(params).then(res => {
          this.tableData = res?.records || [];
          this.pageInfo.total = res?.total || 0;
        });
      },

      /** 退款审核 */
      refundStatus(row, type) {
        const txt = type === 1 ? '通过' : '拒绝';
        YkcDialog({
          showTitle: false,
          showFooter: true,
          dialogType: 'feedback',
          desc: `是否确定${txt}该安心充退款？`,
          onCancel: dialogDone => {
            dialogDone(); // 隐藏弹窗
          },
          onConfirm: dialogDone => {
            orderPage.auditAnxinRefund({ id: row.id, type }).then(res => {
              dialogDone(); // 隐藏弹窗
              this.requestList();
            });
          },
        });
      },

      handleSearchConfirm() {
        this.pageInfo.pageIndex = 1;
        this.requestList();
      },

      handleSearchClean() {
        this.searchParams = {};
        this.pageInfo.pageIndex = 1;
        this.requestList();
      },

      handlePaginationSizeChange(size) {
        this.pageInfo.pageSize = size;
        this.pageInfo.pageIndex = 1;
        this.requestList();
      },

      handlePaginationCurrentChange(page) {
        this.pageInfo.pageIndex = page;
        this.requestList();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .anxin-refund-main {
    padding: 20px;
  }
</style>
